import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Panel from "src/SharedComponents/atoms/Panel";
import Backdrop from "src/SharedComponents/atoms/Backdrop";
import { ModalProps } from "./Modal.types";

import styles from "./Modal.module.css";

function Modal(props: ModalProps) {
  const { isOpen, onClose, children } = props;
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const modalContent: any = isOpen ? (
    <>
      <Backdrop />
      <div
        className={styles.modal}
        role="button"
        tabIndex={0}
        onKeyDown={onClose}
        onClick={onClose}
      >
        <div
          className={styles.modalContent}
          role="button"
          tabIndex={0}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Panel>
            <div className={styles.modalBody}>{children}</div>
          </Panel>
        </div>
      </div>
    </>
  ) : null;

  if (isBrowser) {
    return ReactDOM.createPortal(
      modalContent,
      document.getElementById("modalSlot") as Element
    );
  }

  return null;
}

export default Modal;
